import React from 'react';
import NumberFormat from 'react-number-format';
import { useHistory } from 'react-router-dom';

export const Product = ({ data, onClick }) => {
  const imgStyle = {
    borderRadius: '6px 6px 0 0',
    objectFit: 'cover',
    width: '100%',
    maxWidth: 300,
  }
  const productNameStyle = data.isHighlight ? { 
    fontSize: 21,
    fontWeight: 500,
  } : {
    fontSize: 12, 
    fontWeight: 500,
    textAlign: 'left',
    paddingLeft: 5,
    paddingRight: 5,
  }
  const amountStyle = data.isHighlight ? {
    alignSelf: 'flex-end',
    color: '#00bfe6',
    fontSize: '21px',
    paddingRight: 5,
  } : {
    alignSelf: 'flex-end',
    color: '#00bfe6',
    fontSize: '16px',
    paddingRight: 5,
  }
  const infoStyle = data.isHighlight ? {
    alignSelf: 'flex-end',
    fontSize: '16px',
    paddingRight: 5,
    paddingBottom: 5,
  } : {
    alignSelf: 'flex-end',
    fontSize: '12px',
    paddingRight: 5,
    paddingBottom: 5,
  }
  const history = useHistory();

  const handleClick = () => {
    if (onClick) {
      onClick(data);
    } else {
      history.push('/produk/' + data.code);
    }
  };

  let net_price = data.discount_rate ? data.unit_price.min * (1 - (data.discount_rate / 100)) : data.unit_price.min
  return (
    <div className={['certificate', 'pre_order', 'pre_order_member', 'pre_order_internal'].includes(data.type) || data.code == 'sarung-rs' ? 'highlight' : 'product'} onClick={handleClick}>
      <div style={{ margin: 'auto' }}>
        <img style={imgStyle} alt="produk" src={data.image.url} />
      </div>
      <section>
        <div style={productNameStyle}>{data.name}</div>
        {data.discount_rate && (
          <div style={{ fontSize: 10, textAlign: 'right' }}>
            <span style={{ textDecoration: 'line-through' }}>
              <NumberFormat
                value={data.unit_price.min}
                displayType={'text'}
                thousandSeparator={'.'}
                decimalSeparator={','}
                decimalScale={0}
                prefix={'Rp '}
              />
            </span>
          </div>
        )}
        <strong style={amountStyle}>
          <NumberFormat
            value={net_price}
            displayType={'text'}
            thousandSeparator={'.'}
            decimalSeparator={','}
            decimalScale={0}
            prefix={'Rp '}
          />
        </strong>
        <section style={infoStyle}>
          {data.type === 'pre_order' || data.type === 'pre_order_member' || data.type === 'pre_order_internal' || data.type === 'certificate' ? (
            'Pre Order'
          ) : (
            <NumberFormat
              value={data.quantity.available}
              displayType={'text'}
              thousandSeparator={'.'}
              decimalSeparator={','}
              prefix={'Tersedia: '}
            />
          )}
        </section>
      </section>
    </div>
  );
};
